const state = {
  isDark: false,
  sidebarMini: false,
};

const getters = {
  isDarkMode: state => state.isDark,
  isSidebarMini: state => state.sidebarMini,
};

const actions = {
  toggleTheme({ commit }) {
    commit('TOGGLE_THEME');
  },
  setTheme({ commit }, isDark) {
    commit('SET_THEME', isDark);
  },
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  setSidebarMini({ commit }, isMini) {
    commit('SET_SIDEBAR_MINI', isMini);
  },
};

const mutations = {
  TOGGLE_THEME(state) {
    state.isDark = !state.isDark;
  },
  SET_THEME(state, isDark) {
    state.isDark = isDark;
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebarMini = !state.sidebarMini;
  },
  SET_SIDEBAR_MINI(state, isMini) {
    state.sidebarMini = isMini;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
